module.exports = __webpack_public_path__ + "img/feixinjiaju2.1c81033d.jpg";